import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/solid";

export default function ComparisonFAQ({ title, subtitle, items }) {
  return (
    <section className="py-[100px] px-6 lg:px-10 bg-cream">
      <div className="max-w-[1100px] mx-auto">
        <h2 className="font-inter text-[24px] sm:text-[32px] lg:text-[38px] font-black tracking-[-1.5px] leading-[1.15] mb-4 text-center fade-in">
          {title}
        </h2>
        <p className="font-inter text-base text-gray-cool-500 leading-[1.7] max-w-[700px] mx-auto mb-12 text-center fade-in">
          {subtitle}
        </p>

        <div className="max-w-[760px] mx-auto fade-in">
          {items.map((item, i) => (
            <Disclosure key={i}>
              {({ open }) => (
                <div className="border-b border-gray-cool-200">
                  <Disclosure.Button className="py-6 flex items-center justify-between w-full gap-4 cursor-pointer text-left group">
                    <span className="font-inter text-base font-semibold tracking-[-0.2px] group-hover:text-blue-primary-500 transition-colors">
                      {item.question}
                    </span>
                    <ChevronDownIcon
                      className={`w-4 h-4 text-gray-cool-500 transition-transform duration-300 flex-shrink-0 ${
                        open ? "rotate-180" : ""
                      }`}
                    />
                  </Disclosure.Button>
                  <Disclosure.Panel className="pb-6 font-inter text-sm text-gray-cool-500 leading-[1.75]">
                    {item.answer}
                  </Disclosure.Panel>
                </div>
              )}
            </Disclosure>
          ))}
        </div>
      </div>
    </section>
  );
}
